// When we want to trigger some action that depends on tab state (active/inactive)
import { type DependencyList, useEffect, useRef, useState } from 'react';
import { useTabs } from '../store/context';

export const useTabStateCallback = (options?: {
  onActive?: () => void;
  onInactive?: () => void;
  deps?: DependencyList;
}) => {
  const { onActive, onInactive, deps } = options || {};
  const { activeGlobalTabId } = useTabs();
  const relatedTabId = useRef<number>(activeGlobalTabId);
  const [isActiveTab, setIsActiveTab] = useState(false);
  const isRelatedTabActive = relatedTabId.current === activeGlobalTabId;

  useEffect(() => {
    if (isRelatedTabActive) {
      setIsActiveTab(true);
      onActive?.();
    }
    if (!isRelatedTabActive) {
      setIsActiveTab(false);
      onInactive?.();
    }
  }, [activeGlobalTabId, ...(deps || [])]);

  return { isActiveTab };
};
